<template>
    <transition name="modal" v-if="isActive">
        <perfect-scrollbar class="modal-mask">
            <div class="modal-forget-password modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4>
                            <b-icon icon="pencil-square"></b-icon>
                            <span>ลืมรหัสผ่าน</span>
                        </h4>

                        <button class="btn-close" @click="hide()"><b-icon icon="x"></b-icon></button>
                    </div>
                    <div class="modal-body">
                        <div class="description">
                            <b-icon icon="chat-right-dots"></b-icon>
                            <p>กรอกอีเมลที่ใช้ในการเข้าสู่ระบบร้านค้าของท่าน</p>
                        </div>

                        <div class="form" v-if="formData && errorData">
                            <div class="row">
                                <div class="col-12">
                                    <div class="field">
                                        <input type="text" 
                                                class="input-field"
                                                :class="{ 'invalid': errorData.email.blank }"
                                                maxlength="200"
                                                placeholder="อีเมลที่ใช้เข้าสู่ระบบ"
                                                v-model="formData.email" />
                                        <div class="input-error-message" v-if="errorData.email.blank">โปรดกรอกอีเมลที่ใช้เข้าสู่ระบบของท่าน</div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-right">
                                <button class="btn btn-main" @click="submitForgetPassword()">ส่งคำขอ</button>
                                <button class="btn btn-grey-outline" @click="hide()">ปิด</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </perfect-scrollbar>
    </transition>
</template>

<script>
import Helper from '@/resources/Helper';

export default {
    data() {
        return {
            isActive: false,
            formData: null,
            errorData: null
        };
    },
    props: {
        isDisplay: Boolean
    },
    watch: {
        async isDisplay(value) {
            this.isActive = value;

            if (value) {
                this.formData = await this.initFormData();
                this.errorData = this.initValidateData();
            }
        }
    },
    methods: {
        hide() {
            this.$emit('hide');
        },
        async initFormData() {
            return {
                email: ''
            }
        },
        initValidateData() {
            return {
                email: { blank: false }
            }
        },
        async submitForgetPassword() {
            if (this.validateData()) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                const result = await Helper.postAPI(Helper.getApiUrl(), '/api/forget-password', this.formData);

                if (result) {
                    this.$swal({
                        title: 'ส่งคำขอตั้งรหัสผ่านใหม่ไปแล้ว',
                        text: 'โปรดตรวจสอบอีเมลของท่าน ระบบได้ทำการส่งแบบฟอร์มสำหรับการตั้งรหัสผ่านใหม่ไปให้แล้ว',
                        icon: 'question'
                    }).then(() => {
                        this.hide();
                    });
                } else {
                    this.isShowNetworkError = true;
                }

                loader.hide();
            }
        },
        validateData() {
            this.errorData = this.initValidateData();
            let valid = true;

            for (const property in this.errorData) {
                if (typeof this.formData[property] === 'string' || this.formData[property] instanceof String) {
                    if (!this.formData[property].trim()) {
                        this.errorData[property].blank = true;
                        valid = false;
                    }
                }
            }

            return valid;
        }
    }
}
</script>

<style lang="scss" scoped>
.modal-forget-password {
    max-width: 500px;

    .description {
        font-size: 12px;
        color: #ddd;
        padding-bottom: 20px;
        text-align: center;

        .bi {
            font-size: 100px;
            margin-bottom: 20px;
            opacity: 0.3;
        }

        p {
            margin: auto;
        }

        &:after {
            content: " ";
            display: block;
            margin: 20px auto 0;
            width: 40px;
            height: 1px;
            background: #555;
        }
    }
}
</style>